
const About = () => {
  return (
    <div class="container">
      <h1>About page</h1>
    </div>
  )
}

export default About;